import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CadastroAdicionaisService {
    public nomeProduto = new BehaviorSubject<string>('');
    public nomeGrupo = new BehaviorSubject<string>('');
    public codigoProduto = new BehaviorSubject<number>(0);
    public codigoFamilia = new BehaviorSubject<number>(0);

    constructor() { }
}
